import * as THREE from "three";
import {CAMERA} from "utils/constants";

class Camera {
  static createCamera(graphics, type) {
    let camera = undefined;
    switch (type) {
      case CAMERA.PERSPECTIVE:
        camera = new THREE.PerspectiveCamera(50, graphics.canvas.clientWidth / graphics.canvas.clientHeight, 1, 1000);
        camera.layers.enableAll();
        camera.name = type;
        break;
      case CAMERA.ORTHOGRAPHIC:
        camera = new THREE.OrthographicCamera(-10, 10, 10, -10, 1, 1000);
        camera.layers.enableAll();
        camera.name = type;
        break;
      default:
        break;
    }
    camera.userData.enabled = false;
    camera.userData.depth = 0;
    camera.userData.renderTarget = null;
    // camera.userData.renderTarget = {};
    camera.userData.viewport = {x: 0, y: 0, width: graphics.canvas.clientWidth, height: graphics.canvas.clientHeight};

    return camera;
  }
}
export default Camera;
